



 export const localRouter_meun_land = [ //产业招商大脑导航栏顺序
    //工作台
{
    code: "E",
    switch: true,
    name: "",
    oldtext: "拿地项目库检索",
    type: "ndjs",
    url: "/landSearch",
    open: true,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
{
    code: "B",
    switch: true,
    name: "",
    oldtext: "土地信息监测",
    type: "pxm",
    url: "/landMonitor",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
{
    code: "C",
    switch: true,
    name: "",
    oldtext: "项目推送",
    type: "pxm",
    url: "/pushList",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
{
    code: "D",
    switch: true,
    name: "",
    oldtext: "项目统计",
    type: "pxm",
    url: "/landStatistics",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-order",
    children: []
},
{
    code: "",
    switch: true,
    name: "",
    oldtext: "",
    type: "pxm",
    url: "/",
    open: true,
    morebtn: false,
    icontype: "",
    children: []
},
{
    code: "F",
    switch: true,
    name: "",
    oldtext: "企业数据库",
    type: "pxm",
    url: "/enterpriseList?type=9&Pt=1",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: []
},
{
    code: "G",
    switch: true,
    name: "",
    oldtext: "产业图谱库",
    type: "pxm",
    url: "/allchain",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: []
},
{
    code: "I",
    switch: true,
    name: "",
    oldtext: "研究报告库",
    type: "pxm",
    url: "/report",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: []
},
{
    code: "J",
    switch: true,
    name: "",
    oldtext: "关系计算器",
    type: "pxm",
    url: "/enterprisesCityRelation",
    open: true,
    morebtn: false,
    icontype: "el-icon-s-platform",
    children: []
},

//个人中心
{
    code: "H",
    switch: true,
    name: "",
    oldtext: "个人中心",
    url: "/baseInformation",
    open: false,
    openicon: false,
    morebtn: false,
    icontype: "el-icon-s-custom",
    children: []
},
]
 